export default "__VITE_ASSET__BG548dnw__"